import { AnfrageDisplayModel } from "@/api/model-index";
import { AnfrageService } from "@/api/services/anfrage.service";
import { AnfrageFactory } from "@/core/factories/anfrage.factory";
import { AnfrageContract } from "@/core/models/abstractions/anfrage.contract";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/internal/operators/map";

@Injectable({
    providedIn: 'root'
})
export class AccessableInDraftGuard  {
    protected instance: AnfrageContract | null;
  
    constructor(protected readonly router: Router, protected readonly factory: AnfrageFactory, protected readonly portalContextService: PortalContextService, protected readonly anfrageService: AnfrageService)
    {
        if (this.portalContextService.CurrentAnfrage) {
            this.instance = this.factory.create(this.portalContextService.CurrentAnfrage);
        }
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (! this.instance) {
            await this.getAnfrage(route, state)
                .then((anfrage: AnfrageDisplayModel | undefined) => {
                    if (anfrage)
                        this.instance = this.factory.create(anfrage);
                });
        }

        if (! this.instance?.isInProgress)
        {
            this.router.navigate(['/']);
            return Promise.resolve(false);
        }

        return Promise.resolve(true);
    }

    getAnfrage(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AnfrageDisplayModel | undefined> {
        let id: string = <string>route.params['id'];
          
        return this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: id }).pipe(map((anfrage: AnfrageDisplayModel) => {
          if (anfrage) {
            this.portalContextService.CurrentAnfrage = anfrage;
    
            if (this.portalContextService.CurrentAnfrage)
              return this.portalContextService.CurrentAnfrage;
          }
          
          return undefined;
        })).toPromise();
      }
}